// removed by extract-text-webpack-plugin
module.exports = {"root":"tS52Y"};